// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1qF0z","cell":"ColumnAccessor_cell__HHyZC","firstCellAccent":"ColumnAccessor_firstCellAccent__2Zzhi"};